import { FETCH_DIVISION_LIST_START, FETCH_DIVISION_LIST_SUCCESS, FETCH_DIVISION_LIST_FAIL } from "./actions";

const initialState = {
  divisions: [],
  isFetching: false,
  hasError: false,
};

export default function divisionList(state = initialState, action) {
  switch (action.type) {
    case FETCH_DIVISION_LIST_START:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_DIVISION_LIST_SUCCESS:
      return {
        ...state,
        divisions: action.payload,
        isFetching: false,
        hasError: false,
      };

    case FETCH_DIVISION_LIST_FAIL:
      return {
        ...state,
        isFetching: false,
        hasError: true,
      };

    default:
      return state;
  }
}
